/* eslint-disable no-empty */
import { upload } from "./files.module/upload.module.js";
import { move } from "./files.module/move.module.js";
import { down } from "./files.module/down.module.js";
import FilesService from "@/services/files.service";

export const files = {
    namespaced: true,
    modules: {
        upload,
        move,
        down,
    },
    state: {
        fileArray: [],
        selectArray: [],        
        bRecycle: false,
        rootDir: "",
        curDir: [],
        isForceDelete: false,

        currentFolderSize: "",
        folderSizes: {},
        folderSizeRequestId: 0
    },
    getters: {
        imageFiles(state) {
            return state.fileArray.filter(file => file.type?.startsWith('image/'));
        },
        fileArrayTotalSize: (state) => {
            return state.fileArray.reduce((sum, file) => {
                return sum + (file.meta?.size || 0);
            }, 0);
        },
        selectArrayTotalSize: (state) => {
            return state.selectArray.reduce((sum, file) => {
                return sum + (file.meta?.size || 0);
            }, 0);
        },
        currentDirPath: (state) => {
            return state.curDir.length
                ? "/" + state.curDir.join("/")
                : "/";
        },
        getMtimeMsByFileName: (state) => (fileName) => {
            const target = state.fileArray.find(item => item.name === fileName);

            return target?.meta?.mtimeMs || 0;
        },
    },
    actions: {
        async loadFiles({ commit },{ name, type }) {
            const data = await FilesService.getFileContent(name, type);

            commit("changeFileArray", data.files);
            commit("updateCurDirArray", data.currentDir);

            return data;
        },
        setRootDir({ commit }, file) {
            commit('addRootDir', file)
        },
        setFile({ commit }, file) {
            commit('addFile', file);
        },
        setSortFiles({ commit }) {
            commit('sortFileArray');
        },
        setFiles({ commit }, data) {
            commit("changeFileArray", data.files);
            commit("updateCurDirArray", data.currentDir);
        },
        updateSelected({ state, getters, commit }, tenant) {
            if (tenant.checked) {
                const file = state.fileArray.find(f => f.name === tenant.value);

                if (file) {
                    commit("addSelectedTenant", {
                        path: getters.currentDirPath,
                        name: file.name,
                        isFile: file.isFile,
                        meta: { ...file.meta }
                    });
                }
            } else {
                commit("removeSelectedTenant", tenant.value);
            }
        },
        setCleanSelectArray({ commit } ) {
            commit('cleanSelectArray')
        },        
        setChangeFileName({ commit }, file) {
            commit('changeFileName', file)
        },
        setCleanFileArray({ commit }) {
            commit('cleanFileArray')
        },
        setUpdateCurDirArray({ commit }, dir) {
            commit('updateCurDirArray', dir)
        },
        async renameFile({ commit, state }, payload) {
            const file = await FilesService.postFileRename(
                    payload.oldName,
                    payload.newName,
                    state.curDir.join("/")
                );

            const index = state.fileArray.findIndex(item => item.name === payload.oldName);

            commit("replaceFile", { index, file });

            return file;
        },
        async recycleFiles({ state, dispatch },oldDir) {
            const data = await FilesService.postFileRecycle(
                state.selectArray,
                oldDir,
                state.isForceDelete
            );

            await dispatch("setFiles", data);
            await dispatch("setCleanSelectArray");

            return data;
        },
        async deleteFiles({ state, dispatch }) {
            const files = state.selectArray.map(file => file.name);
            const data = await FilesService.postFileDelete(files);

            await dispatch("setFiles", data);
            await dispatch("setCleanSelectArray");

            return data;
        },
        async loadCurrentFolderSize({ commit, rootGetters }) {
            const dir = rootGetters["files/currentDirPath"];
            commit("setCurrentFolderSize", "계산중...");

            try {
                const data = await FilesService.getFolderSize(dir);

                commit("setCurrentFolderSize", data.size);
            } catch (error) {
                commit("setCurrentFolderSize", "계산 실패");
                console.error(error);
            }
        },
        async loadFolderSize({ commit, rootGetters }, item) {
            const dir = rootGetters["files/currentDirPath"];
            const path = dir === "/" ? `/${item.name}` : `${dir}/${item.name}`;

            commit("setFolderSize", { name: item.name, size: "계산중..." });

            try {
                const data = await FilesService.getFolderSize(path);

                commit("setFolderSize", { name: item.name, size: data.size });
            } catch (error) {
                commit("setFolderSize", { name: item.name, size: "계산 실패" });
                console.error(error);
            }
        },
        async createFolder({ state, dispatch }, newDirName) {
            const isExists = state.fileArray.some(
                item => item.name === newDirName
            );

            if (isExists)
                return false;

            try {
                const file = await FilesService.createFolder(newDirName);
                dispatch("setFile", file);
                dispatch("setSortFiles");

                return true;
            } catch (e) {
                console.error(e);
                return false;
            }
        },
        async createFileLink({ getters }, fileName) {
            const token = await FilesService.postCreateLinkToken(
                fileName,
                getters.currentDirPath
            );

            return `${process.env.VUE_APP_API_URL}file/link/${token}`;
        },
    },
    mutations: {
        addRootDir(state, file) {
            state.rootDir = file;  
        },
        addFile(state, file) {
            const index = state.fileArray.findIndex(item => item.name === file.name);

            if (index === -1) {
                state.fileArray.push(file);
            }
            else {
                state.fileArray[index] = file;
            }
        },
        sortFileArray(state) {
            state.fileArray = state.fileArray.sort((a, b) => {
                const nameA = (a.name || '').toString();
                const nameB = (b.name || '').toString();

                // 폴더 우선 정렬
                if (a.isFile && !b.isFile) return 1;
                if (!a.isFile && b.isFile) return -1;

                // 이름 숫자 기준 자연 정렬
                return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
            });
        },
        changeFileArray(state, file) {
            state.fileArray = file.sort((a, b) => {
                const nameA = (a.name || '').toString();
                const nameB = (b.name || '').toString();

                // 폴더 우선 정렬
                if (a.isFile && !b.isFile) return 1;
                if (!a.isFile && b.isFile) return -1;

                // 이름 숫자 기준 자연 정렬
                return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
            });
        },
        addSelectedTenant(state, tenant) {
            state.selectArray.push(tenant)
            //state.selectArray.sort((a, b) => {  
            //    var nameA = a.name.toUpperCase();
            //    var nameB = b.name.toUpperCase(); 
            //    if (nameA < nameB)
            //        return -1;
            //    else if (nameA > nameB)
            //        return 1;
            //    return 0;
            //});
        },
        removeSelectedTenant(state, name) {
            state.selectArray = state.selectArray.filter(tenant => {
                return tenant.name !== name;
            });
        },
        deleteFile(state) {
            for (const del of state.selectArray) { 
                var index = state.fileArray.findIndex(i => i.name == del.name);
                state.fileArray.splice(index, 1);
            }
            state.selectArray.length = 0;
        },
        cleanSelectArray(state) {
            state.selectArray.length = 0;
        },        
        changeFileName(state, fileName) {
            const index = state.fileArray.findIndex(item => item.name === fileName);

            if (index !== -1) {
                state.fileArray.splice(index, 1);
            }
        },
        cleanFileArray(state) {
            state.fileArray.length = 0;
        },
        updateCurDirArray(state, dir) {
            state.curDir = dir
                ? dir.split("/").filter(Boolean)
                : [];
        },
        changeForceDelete(state, value) {
            state.isForceDelete = value
        },
        replaceFile(state, { index, file }) {
            if (index !== -1) {
                state.fileArray[index] = file;
            }
        },
        setCurrentFolderSize(state, size) {
            state.currentFolderSize = size;
        },
        setFolderSize(state, { name, size }) {
            state.folderSizes[name] = size;
        },
    }
};